<script lang="ts">
  import { getContext } from 'svelte';
  import clsx from 'clsx';
  import StackDivider from './StackDivider.svelte';
  import { contextKey } from './Stack.svelte';
  import type { StackContext, StackItemProps } from './types';

  let {
    children,
    class: className,
    action = () => undefined,
    actionArg,
  }: StackItemProps = $props();
  const context = getContext<StackContext>(contextKey);
  const position = ++context.renderedItems;

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

{#if context.dividers() && position !== 1}
  <StackDivider dividers={context.dividers()} />
{/if}
<div use:elementAction class={clsx(className)}>
  {@render children()}
</div>
